/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Animations from './site/animations';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
import ProductTileDocsPopup from './site/product-tile-docs-popup';
import LoadMoreProducts from './site/load-more-products';
import ProductFinder from './site/product-finder';
import ProductFinderToggle from './site/product-finder-toggle';
import QuoteFormValidation from './site/quote-form-validation';
import DropdownToggle from './site/dropdown-toggle';
import SelectedFiltersToggle from './site/selected-filters-toggle';
import Accordion from './site/accordion';
import QuickSearch from './search/quickSearch';
import RegularSearch from './search/regularSearch';
import Tabs from './site/tabs';
import CaseStudyListing from './site/caseStudyListing';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Animations.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
	ProductTileDocsPopup.init();
	LoadMoreProducts.init();
	ProductFinder.init();
	ProductFinderToggle.init();
	QuoteFormValidation.init();
	DropdownToggle.init();
	SelectedFiltersToggle.init();
	Accordion.init();
	QuickSearch.init();
	RegularSearch.init();
	Tabs.init();
	CaseStudyListing.init();
});
